import { cn } from '@/lib/utils'

interface BxrLogoIconProps {
  size?: 'sm' | 'md' | 'lg'
  className?: string
}

const sizeConfig = {
  sm: 'h-9 w-9 rounded-lg',
  md: 'h-10 w-10 rounded-lg',
  lg: 'h-20 w-20 rounded-2xl',
}

export function BxrLogoIcon({ size = 'sm', className }: BxrLogoIconProps) {
  return (
    <div className={cn('relative overflow-hidden shrink-0', sizeConfig[size], className)}>
      <svg
        className='absolute inset-0 w-full h-full'
        viewBox='248 248 528 528'
        fillRule='evenodd'
        aria-hidden='true'
      >
        {/* Fundo inteiro em primary-foreground — aparece nos cantos e no recorte da luva */}
        <rect x='248' y='248' width='528' height='528' fill='var(--primary-foreground)' />
        {/* Retângulo arredondado em primary com a luva recortada (evenodd) */}
        <g transform='translate(0,1024) scale(0.1,-0.1)' fill='var(--primary)'>
          <path d='M3522 7669 c-424 -56 -762 -336 -900 -744 -63 -186 -62 -150 -62 -1805 0 -1654 -1 -1617 61 -1805 119 -356 404 -620 779 -722 l105 -28 1570 -3 c1751 -3 1674 -6 1865 65 175 65 291 139 418 265 145 144 232 295 291 507 l26 96 3 1560 c2 1093 -1 1585 -8 1645 -55 423 -306 749 -695 903 -194 76 -56 71 -1815 73 -866 1 -1603 -2 -1638 -7z m1653 -990 c274 -34 443 -130 522 -299 69 -146 69 -219 -2 -610 -30 -167 -55 -314 -55 -327 0 -27 33 -47 66 -39 30 8 33 20 89 334 25 139 48 259 51 267 10 26 91 19 159 -14 71 -34 106 -68 137 -136 21 -45 23 -63 22 -195 -1 -115 -7 -171 -27 -271 -71 -341 -231 -646 -386 -737 l-46 -27 -674 -3 c-667 -3 -674 -2 -717 19 -57 27 -89 66 -135 164 -103 222 -166 553 -176 931 -6 239 3 357 38 489 68 263 256 403 599 449 129 17 414 20 535 5z m542 -2185 c60 -44 63 -63 63 -352 0 -291 -3 -307 -63 -339 -30 -17 -79 -18 -677 -18 -690 0 -691 0 -724 50 -8 12 -16 35 -18 51 l-3 29 465 5 465 5 33 23 c53 38 62 67 65 209 2 146 -9 180 -73 218 -34 19 -53 20 -497 23 -298 2 -463 6 -463 13 0 5 7 25 15 45 27 65 7 64 732 61 641 -2 652 -2 680 -23z m-522 -219 c23 -22 25 -32 25 -115 0 -83 -2 -93 -25 -116 l-24 -24 -438 2 -438 3 -3 124 c-1 69 0 131 2 138 4 10 92 13 441 13 l436 0 24 -25z' />
          <path d='M4487 5982 c-15 -16 -17 -49 -17 -250 0 -196 2 -233 16 -246 13 -14 62 -16 383 -16 272 0 370 3 379 12 9 9 12 79 12 255 0 229 -1 243 -19 253 -13 6 -150 10 -379 10 -335 0 -360 -1 -375 -18z' />
        </g>
      </svg>
    </div>
  )
}
